export default function GeminiIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="7" fill="#F1ECFF" />
      <path
        d="M15.5558 15.4685L14.7091 14.82L14.7029 14.8154C14.5264 14.6802 14.4373 14.612 14.338 14.5634C14.2488 14.5198 14.1537 14.488 14.0557 14.4687C13.9451 14.447 13.83 14.447 13.5988 14.447H8.77605C8.155 14.447 7.84411 14.447 7.60667 14.3312C7.39761 14.2292 7.2275 14.0663 7.121 13.8661C7 13.6388 7 13.3414 7 12.7468V8.70053C7 8.10588 7 7.80811 7.121 7.58076C7.2275 7.38058 7.39794 7.21795 7.607 7.11596C7.84467 7 8.15539 7 8.77767 7H15.2221C15.8444 7 16.1558 7 16.3934 7.11596C16.6025 7.21795 16.7724 7.38058 16.8789 7.58076C17 7.80833 17 8.10646 17 8.70228V14.8041C17 15.3709 17 15.6543 16.8786 15.7999C16.7731 15.9265 16.6131 16.0002 16.4439 16C16.2494 15.9998 16.0181 15.8227 15.5558 15.4685Z"
        stroke="#7F56D9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
